/**
 * BigCommerce Integration Registration
 * Registers the BigCommerce integration with the integration registry
 */

import { IntegrationRegistry } from '../registry/IntegrationRegistry';
import { BigCommerceIntegrationFactory } from './BigCommerceIntegrationFactory';

export function registerBigCommerceIntegration(): void {
  const registry = IntegrationRegistry.getInstance();
  
  registry.register(
    'ecommerce:bigcommerce',
    'BigCommerce',
    'ecommerce',
    'bigcommerce',
    '1.0.0',
    new BigCommerceIntegrationFactory()
  );
}